<div
  tabindex="0"
  class="prochaine-etape"
  [ngClass]="{ animation: isAnimationProchaineEtapeDemarree }"
  inViewport
  [inViewportOptions]="{ threshold: [0] }"
  (inViewportAction)="nouvelleVisibiliteProchaineEtape($event)"
  (click)="defilerVersProchaineEtape()"
  (keydown.enter)="defilerVersProchaineEtape()"
  appBlurOnMouseClick
>
  <div class="texte dsd-mb-0">{{ 'carte-prochaine-etape.indicateur-prochaine-etape' | translate }}</div>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 60 66"
    xml:space="preserve"
  >
    <path stroke-linecap="round" stroke-linejoin="round" class="draw-arrow" d="M 30 3 v 60" />
    <path stroke-linecap="round" stroke-linejoin="round" class="draw-arrow" d="M 30 63 l 28 -28" />
    <path stroke-linecap="round" stroke-linejoin="round" class="draw-arrow" d="M 30 63 l -28 -28" />
  </svg>
</div>
<div class="sub-footer" id="sub-footer" [appDynamicBackgroundImage]="getBackgroundImageSource()">
  <app-card-next-step id="app-card-next-step" *ngIf="enableNextStep" [step]="nextStep"></app-card-next-step>
  <app-card-next-step-compact
    id="app-card-next-step-compact"
    *ngIf="enableNextStep"
    [step]="nextStep"
  ></app-card-next-step-compact>

  <app-dialog-faq class="faq-button" buttonStyle="default" position="right" id="'faq'"></app-dialog-faq>
</div>
